import React, { FunctionComponent } from 'react';
import DayForecastItem from '@/components/weather/DayForecastItem';
import styles from './WeekForecastBar.module.scss';
import { Col, Row } from '../layout';

interface IProps {
  forecastDays: {
    time: number; // Will need to massage into a display date
    summary: string; // Also known as conditions
    icon: string; // Could re-map using weather_blurb_from_forecast_io_map
    temperatureHigh: number; // should round to 0
    temperatureLow: number; // should round to 0
  }[];
}

const WeekForecastBar: FunctionComponent<IProps> = ({ forecastDays }) => (
  <div className={styles.WeekForecastBar}>
    <Row justify="space-between">
      {forecastDays.slice(0, 7).map((forecastDay) => (
        <Col key={`dayforecast-${forecastDay.time}`}>
          <DayForecastItem
            time={forecastDay.time}
            summary={forecastDay.summary}
            icon={forecastDay.icon}
            temperatureHigh={forecastDay.temperatureHigh}
            temperatureLow={forecastDay.temperatureLow}
          />
        </Col>
      ))}
    </Row>
  </div>
);

export default WeekForecastBar;
